module.exports = __webpack_public_path__ + "static/media/65.51588685.svg";